import api from './api';

const toFolderPayload = (data = {}) => ({
  name: String(data?.name ?? '').trim(),
  parentId: String(data?.parentId ?? 'root').trim() || 'root',
});

const toArticlePayload = (data = {}) => ({
  title: String(data?.title ?? '').trim(),
  content: String(data?.content ?? ''),
  summary: String(data?.summary ?? '').trim(),
  folderId: String(data?.folderId ?? 'root').trim() || 'root',
  tags: Array.isArray(data?.tags)
    ? data.tags.map((tag) => String(tag ?? '').trim()).filter(Boolean)
    : [],
});

// ---- Home ----
export const getMostViewed = () => api.get('/kb/home').then(r => r.data);

// ---- Folders ----
export const getRootContents = () => api.get('/kb/root').then(r => r.data);
export const getFolderContents = (id) => api.get(`/kb/folder/${id}`).then(r => r.data);
export const createFolder = (data) => api.post('/kb/folder', toFolderPayload(data)).then(r => r.data);
export const renameFolder = (id, name) => api.put(`/kb/folder/${id}`, { name: String(name ?? '').trim() }).then(r => r.data);
export const deleteFolder = (id) => api.delete(`/kb/folder/${id}`).then(r => r.data);

// ---- Articles ----
export const getArticle = (id) => api.get(`/kb/article/${id}`).then(r => r.data);
export const createArticle = (data) => api.post('/kb/article', toArticlePayload(data)).then(r => r.data);
export const updateArticle = (id, data) => api.put(`/kb/article/${id}`, toArticlePayload(data)).then(r => r.data);
export const deleteArticle = (id) => api.delete(`/kb/article/${id}`).then(r => r.data);

// ---- Search ----
export const search = (q) => api.get('/kb/search', { params: { q } }).then(r => r.data);
